export const NONE = 'None';

export const DEFAULT_FIRST_QUARTER_MONTH_END = 3;
export const DEFAULT_SECOND_QUARTER_MONTH_END = 6;
export const DEFAULT_THIRD_QUARTER_MONTH_END = 9;
export const DEFAULT_FOURTH_QUARTER_MONTH_END = 12;

export const DEFAULT_QUARTERS_MONTH_ENDS = [
  DEFAULT_FIRST_QUARTER_MONTH_END,
  DEFAULT_SECOND_QUARTER_MONTH_END,
  DEFAULT_THIRD_QUARTER_MONTH_END,
  DEFAULT_FOURTH_QUARTER_MONTH_END,
];
